<div *ngIf="wfSignedAdmins.length > 0" class="read-only-content">
    <div class="form-container">
      <h4 class="section-title">{{workflowName}} Signed Admins</h4>
    </div>
    <div class="table-responsive">
      <table style="table-layout: fixed;" class="table table-bordered table-striped table-services">
        <thead>
          <tr>
            <th><span>Action</span></th>
            <th><span>User</span></th>
            <th *ngIf="eunitItems.length > 0"><span>Action</span></th>
            <th *ngIf="eunitItems.length > 0"><span>User</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of getMaxLength(measureItems, eunitItems)">
            <td>{{ measureItems[i]?.StepName.split('_')[1] || '' }}</td>
            <td>{{ measureItems[i]?.UserEmail || '' }}</td>
            <td *ngIf="eunitItems.length > 0">{{ eunitItems[i]?.StepName.split('_')[1] || '' }}</td>
            <td *ngIf="eunitItems.length > 0">{{ eunitItems[i]?.UserEmail || '' }}</td>
          </tr>
        </tbody>
        <ng-container *ngIf="managersItems.length > 0">
        <thead>
            <tr>
              <th colspan="2">Action</th>
              <th colspan="2">User</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of managersItems">
              <td colspan="2">{{ item.StepName.split('_')[1] }}</td>
              <td colspan="2">{{ item.UserEmail }}</td>
            </tr>
          </tbody>
        </ng-container>
      </table>
    </div>
  </div>
